import React from 'react';
import { UKFlag } from './UKFlag';
export function AnnouncementBar() {
  return <div className="w-full bg-foreground text-background" data-id="element-26">
      <div className="container mx-auto flex items-center justify-center sm:justify-between gap-6 h-10 text-[12.5px]" data-id="element-27">
        {/* Left: primary message — value-first */}
        <div className="flex items-center gap-2.5 flex-shrink-0" data-id="element-28">
          <UKFlag size={14} data-id="element-29" />
          <span className="text-background/90 leading-none" data-id="element-30">
            Same-day UK dispatch on orders before{' '}
            <span className="text-background font-semibold" data-id="element-31">2pm</span>
          </span>
        </div>

        {/* Right: secondary — research notice */}
        <div className="hidden sm:flex items-center gap-2.5 text-background/65 leading-none" data-id="element-32">
          <span className="hidden lg:inline" data-id="element-33">Independently HPLC-verified</span>
          <span className="hidden lg:inline text-background/30" data-id="element-34">·</span>
          <span data-id="element-35">For research use only · 18+</span>
        </div>
      </div>
    </div>;
}